/**
 * Optional PostHog client for local product-analytics spike (NOV-62).
 * Enabled only when VITE_POSTHOG_KEY is set and import.meta.env.DEV is true.
 */

import posthog from 'posthog-js';

const apiKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const host = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ??
  'http://localhost:8000';

let initialized = false;

export function initPostHog() {
  if (initialized || !apiKey || !import.meta.env.DEV) return;
  posthog.init(apiKey, {
    api_host: host,
    capture_pageview: false,
    capture_pageleave: false,
    persistence: 'sessionStorage',
  });
  initialized = true;
}

export function isPostHogEnabled() {
  return initialized;
}

export function trackPostHogPageview(screenName: string, properties: Record<string, string | number | boolean> = {}) {
  if (!initialized) return;
  posthog.capture('$pageview', {
    screen_name: screenName,
    ...properties,
  });
}

export function trackPostHogPageleave(
  screenName: string,
  durationMs: number,
  properties: Record<string, string | number | boolean> = {},
) {
  if (!initialized) return;
  posthog.capture('$pageleave', {
    screen_name: screenName,
    duration_ms: durationMs,
    ...properties,
  });
}

export function trackPostHogEvent(
  name: string,
  properties: Record<string, string | number | boolean> = {},
) {
  if (!initialized) return;
  posthog.capture(name, properties);
}

export { posthog };
